import DashboardLayout from '../components/Dashboard/Layout/DashboardLayout.vue'
// GeneralViews
import NotFound from '../components/GeneralViews/NotFoundPage.vue'

// used
import Login from 'src/components/Dashboard/Views/Pages/Login.vue'
import ForgotPassword from 'src/components/Dashboard/Views/Pages/ForgotPassword.vue'
import ResetPassword from 'src/components/Dashboard/Views/Pages/ResetPassword.vue'
import AuthAction from 'src/components/Dashboard/Views/Pages/AuthAction.vue'
import Signup from 'src/components/Dashboard/Views/Pages/Signup.vue'
import Register from 'src/components/Dashboard/Views/Pages/Register.vue'
import Confirm from 'src/components/Dashboard/Views/Pages/Confirm.vue'
import RegisterPay from 'src/components/Dashboard/Views/Pages/RegisterPay.vue'
import Reviews from 'src/components/Dashboard/Views/Dashboard/Reviews.vue'
import EmailTemplates from 'src/components/Dashboard/Views/Dashboard/EmailTemplates.vue'
import Profile from 'src/components/Dashboard/Views/Dashboard/Profile.vue'
import Products from 'src/components/Dashboard/Views/Dashboard/Products.vue'
import Product from 'src/components/Dashboard/Views/Dashboard/Product.vue'
import Account from 'src/components/Dashboard/Views/Account/Account.vue'
import Validations from 'src/components/Dashboard/Views/Dashboard/Validations.vue'
import FraudReports from 'src/components/Dashboard/Views/Dashboard/FraudReports.vue'
import Scan from 'src/components/Dashboard/Views/Dashboard/Scan.vue'
import PubScan from 'src/components/Dashboard/Views/Pages/Scan.vue'
import Authenticate from 'src/components/Dashboard/Views/Pages/Authenticate.vue'
import Code from 'src/components/Dashboard/Views/Dashboard/Code.vue'
import MakeAuthCodes from 'src/components/Dashboard/Views/Dashboard/MakeAuthCodes.vue'
import Validate from 'src/components/Dashboard/Views/Validate/Validate.vue'
import RegisterCode from 'src/components/Dashboard/Views/Pages/RegisterCode.vue'
import FraudReport from 'src/components/Dashboard/Views/FraudReport/FraudReport.vue'
import Retailers from 'src/components/Dashboard/Views/Dashboard/Retailers.vue'
import Brands from 'src/components/Dashboard/Views/Dashboard/Brands.vue'
import RegisterKegelbell from 'src/components/Dashboard/Views/Pages/RegisterKegelbell.vue'
import RegisterKegelbellB8ta from 'src/components/Dashboard/Views/Pages/RegisterKegelbellB8ta.vue'
import RegisterKegelbellAmazon from 'src/components/Dashboard/Views/Pages/RegisterKegelbellAmazon.vue'
import RegisterKegelbellBasic from 'src/components/Dashboard/Views/Pages/RegisterKegelbellBasic.vue'
import ProductOverview from 'src/components/Dashboard/Views/Dashboard/ProductOverview.vue'
import Onboarding from 'src/components/Dashboard/Views/Onboarding/Onboarding.vue'
import Plans from 'src/components/Dashboard/Views/Plans/Plans.vue'
import ChangePlan from 'src/components/Dashboard/Views/ChangePlan/ChangePlan.vue'
import RegisterCodeConfirmation from 'src/components/Dashboard/Views/Pages/RegisterCodeConfirmation.vue'
import Amazon from 'src/components/Dashboard/Views/Amazon/Amazon.vue'

// Dashboard pages
import Overview from 'src/components/Dashboard/Views/Dashboard/Overview.vue'
import Stats from 'src/components/Dashboard/Views/Dashboard/Stats.vue'

// Pages
import User from 'src/components/Dashboard/Views/Pages/UserProfile.vue'
import TimeLine from 'src/components/Dashboard/Views/Pages/TimeLinePage.vue'


import Lock from 'src/components/Dashboard/Views/Pages/Lock.vue'

// Components pages
import Buttons from 'src/components/Dashboard/Views/Components/Buttons.vue'
import GridSystem from 'src/components/Dashboard/Views/Components/GridSystem.vue'
import Panels from 'src/components/Dashboard/Views/Components/Panels.vue'
import SweetAlert from 'src/components/Dashboard/Views/Components/SweetAlert.vue'
import Notifications from 'src/components/Dashboard/Views/Components/Notifications.vue'
import Icons from 'src/components/Dashboard/Views/Components/Icons.vue'
import Typography from 'src/components/Dashboard/Views/Components/Typography.vue'

// Forms pages
import RegularForms from 'src/components/Dashboard/Views/Forms/RegularForms.vue'
import ExtendedForms from 'src/components/Dashboard/Views/Forms/ExtendedForms.vue'
import ValidationForms from 'src/components/Dashboard/Views/Forms/ValidationForms.vue'
import Wizard from 'src/components/Dashboard/Views/Forms/Wizard.vue'

// TableList pages
import RegularTables from 'src/components/Dashboard/Views/Tables/RegularTables.vue'
import ExtendedTables from 'src/components/Dashboard/Views/Tables/ExtendedTables.vue'
import PaginatedTables from 'src/components/Dashboard/Views/Tables/PaginatedTables.vue'
// Maps pages
import GoogleMaps from 'src/components/Dashboard/Views/Maps/GoogleMaps.vue'
import FullScreenMap from 'src/components/Dashboard/Views/Maps/FullScreenMap.vue'
import VectorMaps from 'src/components/Dashboard/Views/Maps/VectorMapsPage.vue'

// Calendar
import Calendar from 'src/components/Dashboard/Views/Calendar/CalendarRoute.vue'
// Charts
import Charts from 'src/components/Dashboard/Views/Charts.vue'

// import { CognitoUserPool, CognitoUserAttribute, CognitoUser } from 'amazon-cognito-identity-js'

let componentsMenu = {
  path: '/components',
  component: DashboardLayout,
  redirect: '/components/buttons',
  children: [
    {
      path: 'buttons',
      name: 'Buttons',
      component: Buttons
    },
    {
      path: 'grid-system',
      name: 'Grid System',
      component: GridSystem
    },
    {
      path: 'panels',
      name: 'Panels',
      component: Panels
    },
    {
      path: 'sweet-alert',
      name: 'Sweet Alert',
      component: SweetAlert
    },
    {
      path: 'notifications',
      name: 'Notifications',
      component: Notifications
    },
    {
      path: 'icons',
      name: 'Icons',
      component: Icons
    },
    {
      path: 'typography',
      name: 'Typography',
      component: Typography
    }

  ]
}
let formsMenu = {
  path: '/forms',
  component: DashboardLayout,
  redirect: '/forms/regular',
  children: [
    {
      path: 'regular',
      name: 'Regular Forms',
      component: RegularForms
    },
    {
      path: 'extended',
      name: 'Extended Forms',
      component: ExtendedForms
    },
    {
      path: 'validation',
      name: 'Validation Forms',
      component: ValidationForms
    },
    {
      path: 'wizard',
      name: 'Wizard',
      component: Wizard
    }
  ]
}

let tablesMenu = {
  path: '/table-list',
  component: DashboardLayout,
  redirect: '/table-list/regular',
  children: [
    {
      path: 'regular',
      name: 'Regular Tables',
      component: RegularTables
    },
    {
      path: 'extended',
      name: 'Extended Tables',
      component: ExtendedTables
    },
    {
      path: 'paginated',
      name: 'Paginated Tables',
      component: PaginatedTables
    }]
}

let mapsMenu = {
  path: '/maps',
  component: DashboardLayout,
  redirect: '/maps/google',
  children: [
    {
      path: 'google',
      name: 'Google Maps',
      component: GoogleMaps
    },
    {
      path: 'full-screen',
      name: 'Full Screen Map',
      component: FullScreenMap
    },
    {
      path: 'vector-map',
      name: 'Vector Map',
      component: VectorMaps
    }
  ]
}

let pagesMenu = {
  path: '/pages',
  component: DashboardLayout,
  redirect: '/pages/user',
  children: [
    {
      path: 'user',
      name: 'User Page',
      component: User
    },
    {
      path: 'timeline',
      name: 'Timeline Page',
      component: TimeLine
    }
  ]
}

let validatePage = {
  path: '/validate',
  name: 'Validate',
  component: Validate
}

let fraudReportPage = {
  path: '/fraud-report',
  name: 'FraudReport',
  component: FraudReport
}

let loginPage = {
  path: '/login',
  name: 'Login',
  component: Login
}

let authActionPage = {
  path: '/auth/action',
  name: 'Auth Action',
  component: AuthAction
}

let forgotPasswordPage = {
  path: '/forgot-password',
  name: 'Forgot Password',
  component: ForgotPassword
}

let resetPasswordPage = {
  path: '/reset-password/:oobCode',
  name: 'Reset Password',
  component: ResetPassword
}

let scanPage = {
  path: '/scan',
  name: 'PubScan',
  component: PubScan
}

let authenticate = {
  path: '/authenticate',
  name: 'Authenticate',
  component: Authenticate
}

let registerCode = {
  path: '/register-code',
  name: 'RegisterCode',
  component: RegisterCode
}

let registerCodeConfirmation = {
  path: '/register-code-confirmation',
  name: 'RegisterCodeConfirmation',
  component: RegisterCodeConfirmation
}

let registerKegelbell = {
  path: '/kegelbell',
  name: 'RegisterKegelbell',
  component: RegisterKegelbell
}

let registerKegelbellB8ta = {
  path: '/kegelbell-b8ta',
  name: 'RegisterKegelbellB8ta',
  component: RegisterKegelbellB8ta
}

let registerKegelbellAmazon = {
  path: '/kegelbell-amz',
  name: 'RegisterKegelbellAmazon',
  component: RegisterKegelbellAmazon
}

let registerKegelbellBasic = {
  path: '/kegelbell-basic',
  name: 'RegisterKegelbellBasic',
  component: RegisterKegelbellBasic
}

let signup = {
  path: '/signup',
  name: 'Sign Up',
  component: Signup
}

let confirmPage = {
  path: '/confirm',
  name: 'Confirm',
  component: Confirm
}

let registerPayPage = {
  path: '/register-pay',
  name: 'Register Step 2',
  component: RegisterPay
}

let lockPage = {
  path: '/lock',
  name: 'Lock',
  component: Lock
}

const routes = [
  {
    path: '/',
    component: DashboardLayout,
    redirect: '/admin/products',
    children: [
      {
        path: 'calendar',
        name: 'Calendar',
        component: Calendar
      },
      {
        path: 'charts',
        name: 'Charts',
        component: Charts
      }
    ]
  },
  componentsMenu,
  formsMenu,
  tablesMenu,
  mapsMenu,
  pagesMenu,
  validatePage,
  fraudReportPage,
  registerCode,
  registerCodeConfirmation,
  registerKegelbell,
  registerKegelbellB8ta,
  registerKegelbellAmazon,
  registerKegelbellBasic,
  scanPage,
  authenticate,
  loginPage,
  forgotPasswordPage,
  resetPasswordPage,
  authActionPage,
  signup,
  confirmPage,
  registerPayPage,
  lockPage,
  {
    path: '/admin',
    component: DashboardLayout,
    redirect: '/admin/dashboard',
    children: [
      {
        path: 'onboarding',
        name: 'Onboarding',
        component: Onboarding,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: 'plans',
        name: 'Plans',
        component: Plans,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: 'change-plan',
        name: 'Change Plan',
        component: ChangePlan,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: Overview,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: 'product-dashboard/:id',
        name: 'Product Dashboard',
        component: ProductOverview,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: 'stats',
        name: 'Stats',
        component: Stats
      },
      {
        path: 'reviews',
        name: 'Reviews',
        component: Reviews
      },
      {
        path: 'email-templates',
        name: 'Email Templates',
        component: EmailTemplates
      },
      {
        path: 'profile',
        name: 'Profile',
        component: Profile
      },
      {
        path: 'products',
        name: 'Products',
        component: Products,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: 'product/:productId',
        name: 'Product',
        component: Product,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: 'account',
        name: 'Account',
        component: Account,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: 'amazon',
        name: 'Amazon',
        component: Amazon,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: 'retailers',
        name: 'Retailers',
        component: Retailers,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: 'brands',
        name: 'Brands',
        component: Brands,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: 'validations',
        name: 'Registrations',
        component: Validations
      },
      {
        path: 'fraud-reports',
        name: 'Fraud Reports',
        component: FraudReports
      },
      {
        path: 'scan',
        name: 'Scan',
        component: Scan
      },
      {
        path: 'code',
        name: 'Code',
        component: Code
      },
      {
        path: 'make-auth-codes/:productId',
        name: 'Make Authentic.net Codes',
        component: MakeAuthCodes,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: 'make-auth-codes',
        name: 'Make Authentic.net Codes',
        component: MakeAuthCodes,
        meta: {
          requiresAuth: true
        }
      }
    ]
  },
  {path: '*', component: NotFound}
]

/**
 * Asynchronously load view (Webpack Lazy loading compatible)
 * The specified component must be inside the Views folder
 * @param  {string} name  the filename (basename) of the view to load.
 function view(name) {
   var res= require('../components/Dashboard/Views/' + name + '.vue');
   return res;
};**/

export default routes



// WEBPACK FOOTER //
// ./src/routes/routes.js